module["exports"] = [
  "??# #??",
  "??## #??",
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/address/postcode.js
// module id = 677
// module chunks = 0